<template>
  <div class="header container">
    <div class="vertical-center">
      
      <div id="logo" class="clickable" style="display:inline-block; float: left;" @click="homepage">
        <svg height="40" viewBox="0 0 86 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="86" height="80" rx="10" fill="#CFCCCC" fill-opacity="0.38"/>
        <g filter="url(#filter0_d)">
        <circle cx="43" cy="40" r="33" fill="#4654A3"/>
        </g>
        <g filter="url(#filter1_d)">
        <circle cx="43" cy="40" r="25" fill="#F95B3D"/>
        </g>
        <g filter="url(#filter2_d)">
        <circle cx="43" cy="40" r="18" fill="#E6E9F5"/>
        </g>
        <g filter="url(#filter3_d)">
        <circle cx="43" cy="40" r="13" fill="#270949"/>
        </g>
        <defs>
        <filter id="filter0_d" x="6" y="7" width="74" height="74" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        <filter id="filter1_d" x="14" y="15" width="58" height="58" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        <filter id="filter2_d" x="21" y="22" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        <filter id="filter3_d" x="26" y="27" width="34" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        </defs>
        </svg>
      </div>

      <div style="display:inline-block; float: left; padding:4px" class="clickable" @click="homepage" >
        <svg height="32" viewBox="0 0 144 69" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M55.9736 66.4448C54.0921 67.9943 52.0446 68.6722 49.8311 68.4785C47.6452 68.2848 45.7637 67.2334 44.1865 65.3242C42.637 63.415 41.8761 60.6896 41.9038 57.1479C42.0698 53.5509 42.7339 49.6081 43.896 45.3193C45.0858 41.0306 46.4139 36.7142 47.8804 32.3701C49.5405 27.528 50.8825 23.0456 51.9062 18.9229C52.9023 14.5234 52.9854 11.8395 52.1553 10.8711C51.3252 9.875 49.9279 10.2624 47.9634 12.0332C46.0265 13.7764 43.896 16.5571 41.5718 20.3755C38.8049 24.8302 35.8719 30.4194 32.7729 37.1431C29.7017 43.8667 26.6165 51.9876 23.5176 61.5059C23.2686 62.1423 22.6183 62.4604 21.5669 62.4604C20.5155 62.4328 19.3949 62.1561 18.2051 61.6304C17.0153 61.1047 16.0884 60.3853 15.4243 59.4722C14.7879 58.5591 14.7326 57.5215 15.2583 56.3594C15.8947 55.1143 16.9738 52.6102 18.4956 48.8472C20.0174 45.0565 21.6361 40.6986 23.3516 35.7734C25.0947 30.8206 26.575 25.9924 27.7925 21.2886C29.0099 16.5848 29.6187 12.6973 29.6187 9.62598C29.6463 6.55469 28.6917 4.97754 26.7549 4.89453C24.7627 5.03288 22.6183 6.40251 20.3218 9.00342C18.0252 11.5767 15.8947 14.7863 13.9302 18.6323C11.9933 22.4507 10.5269 26.3105 9.53076 30.2119C8.56234 34.1133 8.36865 37.4613 8.94971 40.2559C9.33708 41.667 10.1533 42.5939 11.3984 43.0366C12.6436 43.4793 13.9993 43.2441 15.4658 42.3311C15.0231 43.6038 13.944 44.5308 12.2285 45.1118C10.5407 45.6929 8.71452 45.762 6.75 45.3193C4.81315 44.849 3.26367 43.673 2.10156 41.7915C0.939453 39.91 0.676595 37.1292 1.31299 33.4492C2.28141 28.5241 4.03841 23.5575 6.58398 18.5493C9.12956 13.5135 12.2147 9.30778 15.8394 5.93213C19.464 2.52881 23.3792 0.77181 27.585 0.661133C31.016 0.77181 33.3125 1.98926 34.4746 4.31348C35.6367 6.61003 36.0794 9.36312 35.8027 12.5728C35.5537 15.7824 35.028 18.8122 34.2256 21.6621C33.4232 24.512 32.7868 26.5319 32.3164 27.7217C32.3441 27.6387 32.3856 27.5418 32.4409 27.4312C33.3263 25.4943 34.5991 22.9349 36.2593 19.7529C37.9471 16.5433 39.9255 13.4028 42.1943 10.3315C44.4909 7.26025 46.9811 4.9222 49.665 3.31738C52.3766 1.6849 55.1712 1.47738 58.0488 2.69482C60.0964 3.55257 61.2585 5.86296 61.5352 9.62598C61.8395 13.3613 60.8711 18.8675 58.6299 26.1445C58.4639 26.7256 58.284 27.3066 58.0903 27.8877C56.5962 32.5915 55.1851 37.2814 53.8569 41.9575C52.5288 46.6336 51.5604 50.8809 50.9517 54.6992C50.3429 58.5176 50.3844 61.5059 51.0762 63.6641C51.7679 65.8499 53.4004 66.7769 55.9736 66.4448ZM77.8462 20.998C77.3758 21.5791 76.6287 21.7728 75.605 21.5791C74.6089 21.3854 73.6958 21.0119 72.8657 20.4585C72.0356 19.8774 71.6759 19.3102 71.7866 18.7568C72.2293 17.318 72.7965 15.7686 73.4883 14.1084C74.2077 12.4482 74.7887 11.2585 75.2314 10.5391C75.8125 9.93034 76.7394 9.77816 78.0122 10.0825C79.3127 10.3592 80.4471 10.8573 81.4155 11.5767C82.384 12.2961 82.7021 13.0155 82.3701 13.7349C81.8997 14.5096 81.208 15.6302 80.2949 17.0967C79.3818 18.5632 78.5656 19.8636 77.8462 20.998ZM95.4854 19.2134C98.8057 20.8459 101.365 22.672 103.164 24.6919C104.99 26.6841 105.391 29.7139 104.367 33.7812C103.786 35.7458 102.666 38.6234 101.005 42.4141C99.4559 45.9557 97.9756 49.6081 96.5645 53.3711C95.181 57.1341 94.3924 60.3438 94.1987 63C94.0327 65.6286 95.015 67.0259 97.1455 67.1919C96.3154 68.437 94.932 68.8382 92.9951 68.3955C91.0859 67.9805 89.3566 66.8322 87.8071 64.9507C86.2576 63.0692 85.8426 60.5651 86.562 57.4385C87.8901 53.2327 89.7855 48.5151 92.248 43.2856C93.7422 40.076 94.9043 37.3783 95.7344 35.1924C96.8688 32.3148 97.2562 29.9214 96.8965 28.0122C96.5645 26.0754 95.015 24.6089 92.248 23.6128C91.8607 28.7316 89.6195 34.7358 85.5244 41.6255C81.4294 48.4875 76.9054 53.2051 71.9526 55.7783C70.7075 56.2487 69.1995 56.2764 67.4287 55.8613C65.6579 55.4463 64.0531 54.7269 62.6143 53.7031C61.1755 52.6794 60.3039 51.5034 59.9995 50.1753C59.8058 48.4045 60.207 45.7482 61.2031 42.2065C62.1715 38.6372 63.3475 35.1509 64.731 31.7476C66.1144 28.3166 67.3042 25.9232 68.3003 24.5674C68.9367 23.848 69.8913 23.6128 71.1641 23.8618C72.4645 24.0832 73.6543 24.6366 74.7334 25.522C75.8402 26.4074 76.1999 27.279 75.8125 28.1367C72.7965 33.2832 70.6799 37.9178 69.4624 42.0405C68.245 46.1632 68.1343 48.5566 69.1304 49.2207C70.5415 49.6357 72.3677 48.778 74.6089 46.6475C76.8501 44.4893 79.0636 41.6532 81.2495 38.1392C83.4631 34.6252 84.9572 31.2357 85.7319 27.9707C86.5343 24.6781 86.0225 22.2432 84.1963 20.666C83.5876 20.1126 83.4492 19.3794 83.7812 18.4663C84.141 17.5532 84.7497 16.6816 85.6074 15.8516C86.4928 15.0215 87.3783 14.4543 88.2637 14.1499C89.1768 13.8179 89.8547 13.9701 90.2974 14.6064C90.7401 15.4089 91.2796 16.1421 91.916 16.8062C92.5524 17.4702 93.7422 18.2726 95.4854 19.2134ZM139.812 32.0381C140.088 31.7614 140.531 31.6922 141.14 31.8306C141.748 31.9412 142.274 32.2041 142.717 32.6191C143.16 33.0342 143.27 33.5184 143.049 34.0718C141.665 36.479 140.033 39.1768 138.151 42.165C136.298 45.1533 134.333 47.9064 132.258 50.4243C130.183 52.9422 128.121 54.7269 126.074 55.7783C124.303 56.4701 122.629 56.304 121.052 55.2803C119.502 54.2288 118.603 52.9976 118.354 51.5864C118.299 50.6733 118.423 49.4836 118.728 48.0171C119.032 46.5229 119.378 45.1395 119.765 43.8667C118.88 44.9181 117.884 46.2048 116.777 47.7266C114.757 50.7148 112.364 53.5648 109.597 56.2764C108.85 56.8574 107.784 56.9819 106.401 56.6499C105.017 56.3179 103.758 55.7091 102.624 54.8237C101.49 53.9383 100.936 52.9561 100.964 51.877C101.462 47.5882 102.942 43.1473 105.405 38.5542C107.867 33.9611 110.593 30.3918 113.581 27.8462C115.241 26.5734 116.749 26.1307 118.105 26.5181C119.488 26.9054 120.886 27.611 122.297 28.6348C122.795 28.9668 123.321 29.3127 123.874 29.6724C124.566 28.8976 125.257 28.0952 125.949 27.2651C126.42 26.6564 126.918 26.0477 127.443 25.439C128.08 24.8302 128.965 24.7057 130.1 25.0654C131.262 25.4251 132.244 26.0339 133.046 26.8916C133.849 27.7217 134.056 28.5518 133.669 29.3818C130.044 35.7181 127.748 40.5741 126.779 43.9497C125.839 47.3254 125.797 49.027 126.655 49.0547C128.841 48.9163 133.226 43.2441 139.812 32.0381ZM120.097 35.1924C120.263 34.9434 120.346 34.556 120.346 34.0303C120.346 33.5046 120.249 33.0203 120.056 32.5776C119.862 32.1073 119.571 31.8306 119.184 31.7476C118.797 31.6369 118.299 31.8859 117.69 32.4946C115.227 35.1232 113.166 38.1392 111.506 41.5425C109.846 44.9181 108.96 47.3254 108.85 48.7642C110.205 47.6297 112.059 45.6099 114.411 42.7046C116.763 39.7993 118.658 37.2952 120.097 35.1924Z" fill="var(--text-dark)"/>
        </svg>
      </div>

      <div style="display:inline-block; float: right; padding:4px; margin-bottom:8px;" >
        
        <el-button class="btntxt header-element" type="text" size="medium" :icon="isDark ? Sunny : Moon" @click="toggleTheme">{{ isDark ? 'Light Theme' : 'Dark Theme' }}</el-button>
        <el-button v-if="showHowToBtn" class="btntxt header-element" type="text" size="medium" :icon="Help" @click="onHowTo">How To</el-button>
        <!--<el-button class="btntxt" style="width:60px;  margin-right:20px" type="text" size="medium" @click="onAbout">About</el-button>-->
      </div>

      <About v-if="showAbout" />

    </div>
  </div>
</template>

<script>
import About from './About.vue'
import { Help, Message, Sunny, Moon } from '@element-plus/icons-vue'

export default {
  name: 'Header',
  components: {
    About
  },
  props: {
    showHowToBtn: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      Help,
      Message,
      Sunny,
      Moon
    }
  },
  data(){
    return{
      showAbout: false,
      isDark: false
    }
  },
  mounted() {
    // Check if user has a system preference for dark theme initially
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.isDark = true;
      document.documentElement.classList.add('dark-theme');
    }
  },
  methods:{
    toggleTheme() {
      this.isDark = !this.isDark;
      if (this.isDark) {
        document.documentElement.classList.add('dark-theme');
      } else {
        document.documentElement.classList.remove('dark-theme');
      }
    },
    onFeedback(){
       window.open('mailto:bhuvanesh.shan92@gmail.com?subject=Feedback for Nira');
    },
    onHowTo(){
      console.log("emitting how-to");
      this.$emit('on-show-how-to');
    },
    onAbout(){
      this.showAbout = true;
    },
    homepage(){
      location.reload();
    }
  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container {
  height: 60px;
  position: relative;
}

.vertical-center {
  margin: 4px;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 100%;
}

.header-element{
  cursor: pointer;
  margin-right:20px; 
  display:inline-block
}

</style>
